import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const CategoryDataSlice = createSlice({
    name: "Category",
    initialState,
    reducers: {
        getCategoryRequest(state) {
            state.loading = true;
        },
        getCategoryRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getCategoryRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    getCategoryRequest,
    getCategoryRequestSuccess,
    getCategoryRequestError,
} = CategoryDataSlice.actions;

export default CategoryDataSlice.reducer;
